import { useEffect } from "react";
import { SignIn } from "@clerk/react-router";
import { Logo } from "@/components/Logo";
import Footer from "@/components/Footer";
import { setMetaDescription, setCanonicalUrl, setOpenGraphTags, setTwitterCardTags, setMetaRobots } from "@/lib/seo";
import { generateWebPageSchema, addSchemaToPage } from "@/lib/schema";

export default function Signin() {
  useEffect(() => {
    const title = "Sign In - Munthly";
    const description = "Sign in to your Munthly account to access your free budgeting dashboard. Track your income, expenses, and savings all in one place.";
    
    document.title = title;
    setMetaDescription(description);
    const canonicalCleanup = setCanonicalUrl("/signin");
    const ogCleanup = setOpenGraphTags(title, description, "/signin");
    const twitterCleanup = setTwitterCardTags(title, description);
    const robotsCleanup = setMetaRobots("noindex, nofollow"); // Don't index signin page
    
    // Add schema for signin page
    const webPageSchema = generateWebPageSchema(
      "/signin",
      title,
      description
    );
    
    const schemaCleanup = addSchemaToPage(webPageSchema);
    
    return () => {
      canonicalCleanup();
      ogCleanup();
      twitterCleanup();
      robotsCleanup();
      schemaCleanup();
    };
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md space-y-6">
          <div className="flex items-center justify-center mb-4">
            <Logo variant="small" className="h-16 w-auto" />
          </div>
          <SignIn
            appearance={{
              elements: {
                rootBox: "mx-auto",
                card: "shadow-none border-0 bg-[var(--surface-container)]",
              },
            }}
            routing="path"
            path="/signin"
            signUpUrl="/signup"
            afterSignInUrl="/dashboard"
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
